export const BulkJobPostRoutes = [
    {
        "url": "/job/bulk-create",
        "name": "appLayout.harriSH.job_bulk_create",
        "type": "frontend",
        "component": 'bulkJobPostContainer',
        "loginRequired": true,
        "showGlobalSearch": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["job_bulk_create"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/bulk-job-post/bulk-job-post.downgrade.module");
                }
            },
        ]
    }
];
//# sourceMappingURL=bulk-job-post.routes.js.map